import axios from 'axios';
import store from '@/store';

const instance = axios.create({
    baseURL: process.env.VUE_APP_HOST_API,
    timeout: 60000,
    headers: {
        'Content-Type': 'application/json'
    }
});

const handleRequest = (config) => {
    let company = localStorage.getItem('_user');
    if (company) {
        company = JSON.parse(company);
        config.headers.Authorization = `Bearer ${company?.token}`;
    }
    return config;
};

const handleResponseSuccess = (response) => {
    return response;
};

const handleResponseError = (error) => {
    if (error?.status === 401) {
        store.commit('segmentedSurveyCompany/setCompany', null);
        return window.location.href = 'login';
    }
    if (error?.status === 302){
        console.log(error);
    }
    return Promise.reject(error);
};

instance.interceptors.request.use(handleRequest);
instance.interceptors.response.use(handleResponseSuccess, handleResponseError);

export default instance;
